import get from 'lodash/get';

/**
 * Convert a product object into a hit object
 * More fields may need to be added as this is used in more places
 *
 * Use formatProduct function in algolia-format to reference how
 * fields are actually built for algolia records
 * https://github.com/BundleStars/amen/blob/master/app/services/algolia/algolia-format.js#L437
 *
 * @param  {Object} product
 * @return {Object}
 */
export default product => ({
  objectID: product._id,
  _id: product._id,
  name: product.name,
  product_id: product._id, // consistent with algolia
  type: product.type,
  display_type: product.display_type,
  slug: product.slug,
  cover: product.cover,
  cover_type: product.cover_type,
  bundles: product.bundles,
  presale: product.presale,
  downloads: product.downloads,
  hide_discount: product.hideDiscount,
  files: product.files,
  drm: Object.keys(product.drm || {}).filter(d => product.drm[d]),
  price: {
    GBP: get(product, 'currentPrice.GBP', get(product, 'price.GBP', 0)) / 100,
    USD: get(product, 'currentPrice.USD', get(product, 'price.USD', 0)) / 100,
    EUR: get(product, 'currentPrice.EUR', get(product, 'price.EUR', 0)) / 100,
    CAD: get(product, 'currentPrice.CAD', get(product, 'price.CAD', 0)) / 100,
    AUD: get(product, 'currentPrice.AUD', get(product, 'price.AUD', 0)) / 100,
    RUB: get(product, 'currentPrice.RUB', get(product, 'price.RUB', 0)) / 100,
    JPY: get(product, 'currentPrice.JPY', get(product, 'price.JPY', 0)) / 100,
  },
  fullPrice: {
    GBP: get(product, 'fullPrice.GBP', get(product, 'price.GBP', 0)) / 100,
    USD: get(product, 'fullPrice.USD', get(product, 'price.USD', 0)) / 100,
    EUR: get(product, 'fullPrice.EUR', get(product, 'price.EUR', 0)) / 100,
    CAD: get(product, 'fullPrice.CAD', get(product, 'price.CAD', 0)) / 100,
    AUD: get(product, 'fullPrice.AUD', get(product, 'price.AUD', 0)) / 100,
    RUB: get(product, 'fullPrice.RUB', get(product, 'price.RUB', 0)) / 100,
    JPY: get(product, 'fullPrice.JPY', get(product, 'price.JPY', 0)) / 100,
  },
  discount_percent: get(product, 'current_discount.percent', 0) * 100,
  operating_systems: Object.keys(product.platforms || {}).filter(k => product.platforms[k]),
  ubisoft_ska: product.ubisoft_ska ? product.ubisoft_ska : false,
  origin_ska: product.origin_ska ? product.origin_ska : false,
  epic_ska: product.epic_ska ? product.epic_ska : false,
  age_ratings: get(product, 'age', {}),
  categories: get(product, 'categories', []),
  publishers: get(product, 'publishers', []),
  franchises: get(product, 'franchises', []),
  video: product.video,
  total_ratings: get(product.userReviewSummary, 'total_ratings'),
  rating_score: get(product.userReviewSummary, 'rating_score'),
  metacritic_score: get(product, 'metaCritic.score', null),
  opencritic_score: get(product, 'openCritic.score', null),
  steam_deck_support: get(product, 'steam.deck_support', null),
  video_clip_files: product?.videoClipFiles,
  screenshots: (product?.img || []).sort((a, b) => a.order - b.order).slice(0, 6).map(s => s.slug),


  // Fields only set in pick and mix products
  low_stock: product.low_stock,
  total_game_index: product.totalGameIndex,
  soldOut: product.soldOut,
});
